var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import Signals from '../../../../signals/Signals';
/**
 *
 */
var LoadingScreen = /** @class */ (function (_super) {
    __extends(LoadingScreen, _super);
    /**
     *
     * @param props
     */
    function LoadingScreen(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showLoadingScreen: false };
        _this.show = _this.show.bind(_this);
        _this.hide = _this.hide.bind(_this);
        _this.onUploadProgress = _this.onUploadProgress.bind(_this);
        return _this;
    }
    /**
     *
     */
    LoadingScreen.prototype.componentDidMount = function () {
        Signals.ShowLoadingScreen.add(this.show);
        Signals.HideLoadingScreen.add(this.hide);
        Signals.ProgressUpload.add(this.onUploadProgress);
    };
    LoadingScreen.prototype.componentWillUnmount = function () {
        Signals.ShowLoadingScreen.remove(this.show);
        Signals.HideLoadingScreen.remove(this.hide);
    };
    /**
     *
     * @return {*}
     */
    LoadingScreen.prototype.render = function () {
        var _this = this;
        var classes = classNames({
            'loading-screen--show': this.state.showLoadingScreen,
            'loading-screen--hide': !this.state.showLoadingScreen
        });
        return (React.createElement("div", { className: "loading-screen ".concat(classes) },
            React.createElement("div", { className: "loading-screen__background" }),
            React.createElement("div", { className: "loading-screen__upload-progress", ref: function (ref) { return _this.progressBar = ref; } }),
            React.createElement("div", { className: "loading-screen__animation spinner-border text-primary", role: "status" },
                React.createElement("span", { className: "sr-only" }, "Loading..."))));
    };
    /**
     *
     * @param percentage
     */
    LoadingScreen.prototype.onUploadProgress = function (percentage) {
        if (this.progressBar) {
            this.progressBar.style.width = percentage + '%';
        }
    };
    /**
     *
     */
    LoadingScreen.prototype.show = function () {
        if (!this.state.showLoadingScreen) {
            this.onUploadProgress(0);
            this.setState({ showLoadingScreen: true });
        }
    };
    /**
     *
     */
    LoadingScreen.prototype.hide = function () {
        if (this.state.showLoadingScreen) {
            this.setState({ showLoadingScreen: false });
        }
    };
    return LoadingScreen;
}(React.Component));
export default LoadingScreen;
